angular
  .module('linshare.guests')
  .constant('GUEST_MODERATOR_ROLES', ['SIMPLE', 'ADMIN']);
